import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.output.css'; // precompiled Tailwind (see package.json prebuild)
import './index.css';
import App from './App';
import VerifiedAccess from './components/VerifiedAccess';
import AppErrorBoundary from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary><VerifiedAccess><App /></VerifiedAccess></AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Keep the web version available from the home screen after it has been opened
// once. Native Capacitor builds ignore service workers entirely.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.warn('TapTap offline support unavailable:', error?.message);
    });
  });
}
